import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import config from '../config';

export default function Guide() {
  const location = useLocation();
  const { GUIDE_PATH } = config;
  // The hash is part of src, so a hash change updates the iframe's src and the
  // browser navigates it: a same-document fragment jump when only the hash
  // differs, otherwise a reload of the entry file, whose redirect map sends the
  // reader to the file that owns the section. No effect is needed on top.
  const src = `${GUIDE_PATH}${location.hash || ''}`;

  return (
    <Box sx={{ height: 'calc(100vh - 96px)', width: '100%' }}>
      <iframe
        title="Store Social Field Guide"
        src={src}
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </Box>
  );
}
